import React, { useEffect, useRef, useState } from "react";
import { Box, Link as MuiLink, Grid, makeStyles, Theme, TextField } from "@material-ui/core";
import { Tooltip } from "@mui/material";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { columns } from "./components/columns";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { ManagementRoute } from "../../management.routes";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import { selectAllApprovalUserList } from "src/app-redux/configuration/configurationSlice";
import { getAllApprovalUser } from "src/app-redux/configuration/actions/configurationActions";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import { useFormik } from "formik";
import { object, string } from "yup";
import {
  getVehicleDetailsByIdAction,
  markVehicleEntryAsReject,
  markVehicleEntryAsReview,
  markVehicleEntryAsWrong,
} from "src/app-redux/vehicle/actions/vehicleActions";
import { loader as invalidLoader, setSelectedVehicleId } from "src/app-redux/vehicle/vehicleSlice";
import Drawer from "./components/Drawer/Drawer";
import CommonButton from "src/components/CommonButton/CommonButton";
import moment from "moment";
import "moment-timezone";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import { filteryByArr } from "src/common/utils/app.dropdowns";
import { filterBy } from "src/common/utils/helpers";
import { searchData } from "src/app-redux/common-actions";
import { GridRowModel } from "@material-ui/x-grid";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
    //lineHeight: "28px",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  link: {
    backgroundColor: "#72CA00",
    padding: "8px",
    borderRadius: "5px",
    color: "white",
    textDecoration: "none",
  },
  hideDatesGrid: {
    display: "none",
  },
}));

interface Props {}

export function ListApprovals({}: Props): React.ReactElement {
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const dispatch = useAppDispatch();
  const pageHeading = "List of Approvals";
  const moduleName = ManagementRoute.title;
  const [isOpenConfirmationDailog, setIsOpenConfirmationDailog] = useState<boolean>(false);
  const [isOpenApproveConfirmationDailog, setIsOpenApproveConfirmationDailog] =
    useState<boolean>(false);
  const [isOpenRejectConfirmationDailog, setIsOpenRejectConfirmationDailog] =
    useState<boolean>(false);
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const [remarks, setRemarks] = useState("");
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);
  const [resetHandler, setResetHandler] = useState(false);
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const [loader, setLoader] = useState<any>(false);
  const loader2: any = useAppSelector(invalidLoader);

  const allApprovalUserList = useAppSelector(selectAllApprovalUserList);
  const td = new Date();

  const formik = useFormik<any>({
    initialValues: {
      InProgressVehiclesDataOnly: true,
      filterBy: "lastMonth",
      startDate: moment(new Date(new Date().setDate(td.getDate() - 29)).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(td.getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      invalidRemarks: "",
      approvalUserId: "",
      userName: "",
      invalidVehicleId: null,
      regNumber: "",
    },
    validationSchema: object({
      invalidRemarks: string()
        .required("This field is required")
        .max(3000, "Maximum 3000 characters are allowed"),
      approvalUserId: string().required("This field is required"),
    }),
    onSubmit: async (values) => {
      const params = {
        gatePassId: values.invalidVehicleId,
        invalidRemarks: values?.invalidRemarks,
        approvalUserId: values.approvalUserId,
        userName: values.userName,
        regNumber: values.regNumber,
      };
      if (values.invalidVehicleId) {
        handleCloseConfirmationDialog();

        const res: any = await dispatch(markVehicleEntryAsReview(params));
        if (res.payload) {
          formik.setFieldValue("invalidRemarks", "");
          handleSearch();
        }
      }
    },
  });

  const formikForApproval = useFormik<any>({
    initialValues: {
      remarks: "",
    },
    validationSchema: object({
      remarks: string()
        .required("This field is required")
        .max(3000, "Maximum 3000 characters are allowed"),
    }),
    onSubmit: async (values) => {
      const remarksSeparation = "@``@";
      const remarksConcat: any = `${remarks} ${remarksSeparation} ${values?.remarks}`;
      const params = {
        gatePassId: formik.values.invalidVehicleId,
        remarks: remarksConcat,
      };
      if (formik.values.invalidVehicleId) {
        handleApproveCloseConfirmationDialog();
        const res: any = await dispatch(markVehicleEntryAsWrong(params));
        if (res.payload) {
          formikForApproval.setFieldValue("remarks", "");
          handleSearch();
        }
      }
    },
  });
  const formikForReject = useFormik<any>({
    initialValues: {
      remarks: "",
    },
    validationSchema: object({
      remarks: string()
        .required("This field is required")
        .max(3000, "Maximum 3000 characters are allowed"),
    }),
    onSubmit: async (values) => {
      const remarksConcat: any = `${values?.remarks}`;
      const params = {
        gatePassId: formik.values.invalidVehicleId,
        remarks: remarksConcat,
      };
      if (formik.values.invalidVehicleId) {
        handleRejectCloseConfirmationDialog();
        const res: any = await dispatch(markVehicleEntryAsReject(params));
        if (res.payload) {
          formikForReject.setFieldValue("remarks", "");
          handleSearch();
        }
      }
    },
  });

  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };

  const handleRejectConfirmationDialog = async () => {
    formikForReject.submitForm();
  };

  const handleRejectCloseConfirmationDialog = () => {
    setIsOpenRejectConfirmationDailog(false);
  };

  const handleApproveConfirmationDialog = async () => {
    formikForApproval.submitForm();
  };

  const handleApproveCloseConfirmationDialog = () => {
    setIsOpenApproveConfirmationDailog(false);
  };

  const handleConfirmationDialog = async () => {
    formik.submitForm();
  };

  const handleCloseConfirmationDialog = () => {
    formik.resetForm();
    setIsOpenConfirmationDailog(false);
  };

  const resetSearch = () => {
    formik.setValues(formik.initialValues);
    setIsCustomDate(false);
    setResetHandler(true);
  };

  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };

  const handleSearch = async () => {
    const { filterBy, startDate, endDate, InProgressVehiclesDataOnly } = formik.values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      InProgressVehiclesDataOnly: InProgressVehiclesDataOnly || false,
      userId: Number(localStorage.getItem("nodUserId")),
    };
    setvehicleRecord([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/gate-pass-get-all-pending-review-vehicles", JSON.stringify(body))
      );
      const apiRecord = results?.gateEnteries;
      if (apiRecord) {
        const transformedData = apiRecord.map((data: any) => {
          return {
            ...data,
            id: data.gatePassId,
            yardSlotInfo:
              data.yardName && data.rowName && data.slotNumber
                ? `${data.yardName}, Row ${data.rowName}, Slot ${data.slotNumber}`
                : "",
          };
        });
        setvehicleRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };

  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "remarks"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue }: any) {
                return (
                  <Tooltip title={renderedCellValue} followCursor>
                    <span>{renderedCellValue}</span>
                  </Tooltip>
                );
              },
            }
          : column.accessorKey === "vehicleNumber"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <>
                    <MuiLink
                      className="customMuiLink"
                      onClick={() => {
                        dispatch(getVehicleDetailsByIdAction(row.original.id));
                        dispatch(setSelectedVehicleId(row.original.id));
                        setisDrawerOpen(true);
                      }}
                    >
                      {renderedCellValue}
                    </MuiLink>
                  </>
                );
              },
            }
          : column.accessorKey === "action"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <>
                    <NewCommonButton
                      onClick={() => {
                        setRemarks(row.original?.inspectorComments);
                        formik.setFieldValue("invalidVehicleId", row.original.id);
                        formik.setFieldValue("regNumber", row.original.vehicleNumber);
                        setIsOpenApproveConfirmationDailog(true);
                      }}
                      icon={<DoneIcon />}
                      isEdit={true}
                    >
                      Approve
                    </NewCommonButton>
                    <NewCommonButton
                      onClick={() => {
                        setRemarks(row.original?.inspectorComments);
                        formik.setFieldValue("invalidVehicleId", row.original.id);
                        formik.setFieldValue("regNumber", row.original.vehicleNumber);
                        setIsOpenRejectConfirmationDailog(true);
                      }}
                      icon={<CloseIcon />}
                    >
                      Reject
                    </NewCommonButton>
                  </>
                );
              },
            }
          : column.accessorKey === "assignto"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <>
                    <NewCommonButton
                      onClick={() => {
                        formik.setFieldValue("invalidVehicleId", row.original.id);
                        formik.setFieldValue("regNumber", row.original.vehicleNumber);
                        setIsOpenConfirmationDailog(true);
                      }}
                      isEdit={true}
                    >
                      Reassign User
                    </NewCommonButton>
                  </>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);

  useEffect(() => {
    formik.setFieldValue("filterBy", "lastMonth");
    handleSearch();
    setResetHandler(false);
    dispatch(getAllApprovalUser(true));
  }, [resetHandler]);

  // const { height } = UseWindowDimensions();

  return (
    <>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />
      <Box m={2} />
      <CommonDataGridPage
        module={moduleName}
        heading={pageHeading}
        GridDataComp={
          <CommonMaterialGrid
            defaultPerPageRecord={15}
            height={550}
            loader={loader || loader2}
            rows={vehicleRecord || []}
            columns={displayColumns}
          />
        }
      >
        <>
          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={3} lg={2}>
              <CommonAutoCompleteField
                cssClassName="customTextField"
                error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                helperText={formik.touched.filterBy && formik.errors.filterBy}
                label="Filter by"
                placeholder="Filter by"
                name="filterBy"
                disableClearable={true}
                optionsType={filteryByArr}
                getOptionLabel={(option: any) => option.label || null}
                onChange={(row: any) => {
                  row ? formik.setValues({ ...formik.values, filterBy: row.value || "" }) : "";
                  if (row === null) {
                    formik.setFieldValue("filterBy", null);
                  }
                  filterByAction(row);
                }}
                value={
                  filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                }
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2} className={!isCustomDate ? classes.hideDatesGrid : ""}>
              <CommonTextFieldDate
                cssClassName="customTextField"
                label={"Start Date"}
                name={"startDate"}
                datePickerRef={startDatePickerRef}
                value={formik.values.startDate}
                onChange={(e: any) => {
                  formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  formik.setFieldValue("endDate", "");
                }}
                maxDate={moment().format("YYYY-MM-DDTHH:mm")}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2} className={!isCustomDate ? classes.hideDatesGrid : ""}>
              <CommonTextFieldDate
                cssClassName="customTextField"
                label={"End Date"}
                name={"endDate"}
                datePickerRef={endDatePickerRef}
                value={formik.values.endDate}
                onChange={(e: any) => {
                  formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                }}
                minDate={formik.values.startDate}
                maxDate={moment().format("YYYY-MM-DDTHH:mm")}
              />
            </Grid>
            <Grid item xs={12} md={isCustomDate ? 3 : 4} lg={2} style={{ paddingRight: 0 }}></Grid>

            <Grid item xs={12} md={isCustomDate ? 12 : 5} lg={isCustomDate ? 4 : 8}>
              <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
                  Search
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </>
      </CommonDataGridPage>
      <TransitionDialog
        isOpen={isOpenConfirmationDailog}
        handleClose={() => handleCloseConfirmationDialog()}
        heading={"Confirmation"}
        handleConfirm={() => handleConfirmationDialog()}
      >
        Are you sure you want to reassign this user?
        <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TextField
            required
            multiline
            rows={1}
            rowsMax={5}
            size="small"
            fullWidth
            className="customTextField"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            label="Remarks"
            name="invalidRemarks"
            id="invalidRemarks"
            placeholder="Enter Remarks"
            disabled={false}
            value={formik.values.invalidRemarks}
            onChange={(e) => formik.setFieldValue("invalidRemarks", e.target.value)}
            error={formik.touched.invalidRemarks && Boolean(formik.errors.invalidRemarks)}
            helperText={formik.touched.invalidRemarks && formik.errors.invalidRemarks}
          />
        </Box>
        <Box>
          <CommonAutoCompleteField
            cssClassName="customTextField"
            disabled={false}
            label="Assign to"
            name="userId"
            placeholder="Select User"
            disableClearable={true}
            optionsType={allApprovalUserList?.filter(
              (list: any) => list?.userId != Number(localStorage?.getItem("nodUserId"))
            )}
            getOptionLabel={(option) => `${option.userName}`}
            required
            value={
              allApprovalUserList.find((st: any) => st.userId === formik.values.approvalUserId) ||
              null
            }
            onChange={(option: any) => {
              formik.setFieldValue("approvalUserId", option.userId);
              formik.setFieldValue("userName", option.userName);
            }}
            error={formik.touched.approvalUserId && Boolean(formik.errors.approvalUserId)}
            helperText={formik.touched.approvalUserId && formik.errors.approvalUserId}
          />
        </Box>
      </TransitionDialog>
      <TransitionDialog
        isOpen={isOpenApproveConfirmationDailog}
        handleClose={() => handleApproveCloseConfirmationDialog()}
        heading={"Confirmation"}
        handleConfirm={() => handleApproveConfirmationDialog()}
      >
        Are you sure you want to mark as invalid?
        <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TextField
            required
            multiline
            rows={1}
            rowsMax={5}
            size="small"
            fullWidth
            className="customTextField"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            label="Remarks"
            name="remarks"
            id="remarks"
            placeholder="Enter Remarks"
            disabled={false}
            value={formikForApproval.values.remarks}
            onChange={(e) => formikForApproval.setFieldValue("remarks", e.target.value)}
            error={formikForApproval.touched.remarks && Boolean(formikForApproval.errors.remarks)}
            helperText={formikForApproval.touched.remarks && formikForApproval.errors.remarks}
          />
        </Box>
      </TransitionDialog>
      <TransitionDialog
        isOpen={isOpenRejectConfirmationDailog}
        handleClose={() => handleRejectCloseConfirmationDialog()}
        heading={"Confirmation"}
        handleConfirm={() => handleRejectConfirmationDialog()}
      >
        Are you sure you want to reject this approval?
        <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TextField
            required
            multiline
            rows={1}
            rowsMax={5}
            size="small"
            fullWidth
            className="customTextField"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            label="Remarks"
            name="remarks"
            id="remarks"
            placeholder="Enter Remarks"
            disabled={false}
            value={formikForReject.values.remarks}
            onChange={(e) => formikForReject.setFieldValue("remarks", e.target.value)}
            error={formikForReject.touched.remarks && Boolean(formikForReject.errors.remarks)}
            helperText={formikForReject.touched.remarks && formikForReject.errors.remarks}
          />
        </Box>
      </TransitionDialog>
    </>
  );
}
